import React, { Component } from 'react';
import './index.scss';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data3_2_1, data9_2 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";

const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            data9: [{}],
            loading: true,
            loadingSave: false,
            print: false
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };
        const nameData = ['zeroDay', 'threeDay', 'sixDay', 'nineDay', 'overDay', 'totalDay'];
        data[0].totalDay = nameData.reduce((a, b) => {
            if (b != 'totalDay') {
                a += numConvert(data[0][b]);
            }
            return a
        }, 0);
        data[0].totalDay = data[0].totalDay.toFixed(0);

        const percentData = ['zeroPercent', 'threePercent', 'sixPercent', 'ninePercent', 'overPercent', 'totalPercent'];
        for (let i = 0; i < 6; i++) {
            data[0][percentData[i]] = (numConvert(data[0].totalDay) == 0 ? 0 : (numConvert(data[0][nameData[i]]) / numConvert(data[0].totalDay))).toFixed(3);
        }

        return data
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;

        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data3_2_1);
        let data = JSON.parse(dataBegin);
        this.getTitle(date);
        fetch(`/_9_2_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }

            this.setState({ data });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    getTitle = (date) => {
        const dataBegin = JSON.stringify(data9_2);
        let data = JSON.parse(dataBegin);

        fetch(`/_9_2_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({
                data9: data,
                loading: false
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (this.state.data9[0].day <= 0) {
            message.error('请填写周转天数！');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        this.onSaveTitle();
        fetch('/add_9_2', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onSaveTitle = () => {
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data9.map(x => ({ ...x, year, month }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_9_2_1', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_2', 1.5, '9.20', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const data9 = this.state.data9;
        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 receivable">
                    <Row className="title" id="table9_2">
                        <Row>9.2 Accounts Receivable 应收账款 </Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                            <span style={{ marginLeft: 10, fontSize: 16 }}>注:只需填上5万以上的应收款</span>
                        </Row>
                        {this.state.loading && !this.state.print ? null : <div>

                            <div className="receive-row" style={{ marginTop: 20 }}>
                                <div className="row-left">
                                    Days of Credit Sales Outstanding (DCSO) 周转天数
                                </div>
                                <div className="row-right">
                                    <Row>
                                        <Compared data={{ index: 0, key: 'day', title: [''], sqlName: "_9_2_1", name: 'Days of Credit Sales Outstanding (DCSO) 周转天数', type: 'number' }}>
                                            <Col span={8} style={{ padding: "0 10px" }} className="border-right-input">
                                                <InputNumber
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    precision={0}
                                                    className="table_numInput"
                                                    style={{ width: '100%', marginTop: 5 }}
                                                    defaultValue={Number(data9[0].day || '0') || ''}
                                                    onBlur={(e) => {
                                                        let data9 = this.state.data9;
                                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                        value = Number(value.toFixed(0));
                                                        data9[0].day = value;
                                                        this.setState({
                                                            data9
                                                        });
                                                    }}

                                                />
                                            </Col>
                                        </Compared>
                                        <Col span={16}></Col>
                                    </Row>

                                </div>
                            </div>
                            <div className="receive-row" >
                                <div className="row-left">
                                    Aging 账龄
                                </div>
                                <div className="row-right">
                                    <Row style={{ textAlign: "center" }}>
                                        <Col span={4} className="border-right-background">0-30Days</Col>
                                        <Col span={4} className="border-right-background">31-60Days</Col>
                                        <Col span={4} className="border-right-background">61-90Days</Col>
                                        <Col span={4} className="border-right-background">91-120Days</Col>
                                        <Col span={4} className="border-right-background">Over 120 Days</Col>
                                        <Col span={4} className="border-right-background">Total Balance</Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="receive-row" >
                                <div className="row-left">
                                    Amount 金额
                                </div>
                                <div className="row-right">
                                    <Row style={{ textAlign: "center" }}>
                                        <Col span={4} className="border-right-input">
                                            <Compared data={{ index: 0, key: 'zeroDay', title: ['0-30Days'], sqlName: "_9_2_1", name: 'Amount 金额', type: 'number' }}>
                                                <InputNumber
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    precision={0}
                                                    className="table_numInput"
                                                    defaultValue={Number(data9[0].zeroDay || '0') || ''}
                                                    onBlur={(e) => {
                                                        let data9 = this.state.data9;
                                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                        value = Number(value.toFixed(0));
                                                        data9[0].zeroDay = value;
                                                        data9 = this.computeNum(data9);
                                                        this.setState({
                                                            data9
                                                        });
                                                    }}
                                                />
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right-input">
                                            <Compared data={{ index: 0, key: 'threeDay', title: ['31-60Days'], sqlName: "_9_2_1", name: 'Amount 金额', type: 'number' }}>
                                                <InputNumber
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    precision={0}
                                                    className="table_numInput"
                                                    defaultValue={Number(data9[0].threeDay || '0') || ''}
                                                    onBlur={(e) => {
                                                        let data9 = this.state.data9;
                                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                        value = Number(value.toFixed(0));
                                                        data9[0].threeDay = value;
                                                        data9 = this.computeNum(data9);
                                                        this.setState({
                                                            data9
                                                        });
                                                    }}
                                                />
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right-input">
                                            <Compared data={{ index: 0, key: 'sixDay', title: ['61-90Days'], sqlName: "_9_2_1", name: 'Amount 金额', type: 'number' }}>
                                                <InputNumber
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    precision={0}
                                                    className="table_numInput"
                                                    defaultValue={Number(data9[0].sixDay || '0') || ''}
                                                    onBlur={(e) => {
                                                        let data9 = this.state.data9;
                                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                        value = Number(value.toFixed(0));
                                                        data9[0].sixDay = value;
                                                        data9 = this.computeNum(data9);
                                                        this.setState({
                                                            data9
                                                        });
                                                    }}
                                                />
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right-input">
                                            <Compared data={{ index: 0, key: 'nineDay', title: ['91-120Days'], sqlName: "_9_2_1", name: 'Amount 金额', type: 'number' }}>
                                                <InputNumber
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    precision={0}
                                                    className="table_numInput"
                                                    defaultValue={Number(data9[0].nineDay || '0') || ''}
                                                    onBlur={(e) => {
                                                        let data9 = this.state.data9;
                                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                        value = Number(value.toFixed(0));
                                                        data9[0].nineDay = value;
                                                        data9 = this.computeNum(data9);
                                                        this.setState({
                                                            data9
                                                        });
                                                    }}
                                                />
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right-input">
                                            <Compared data={{ index: 0, key: 'overDay', title: ['Over 120 Days'], sqlName: "_9_2_1", name: 'Amount 金额', type: 'number' }}>
                                                <InputNumber
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    precision={0}
                                                    className="table_numInput"
                                                    defaultValue={Number(data9[0].overDay || '0') || ''}
                                                    onBlur={(e) => {
                                                        let data9 = this.state.data9;
                                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                        value = Number(value.toFixed(0));
                                                        data9[0].overDay = value;
                                                        data9 = this.computeNum(data9);
                                                        this.setState({
                                                            data9
                                                        });
                                                    }}
                                                />
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right">
                                            <Compared data={{ index: 0, key: 'totalDay', title: ['Total Balance'], sqlName: "_9_2_1", name: 'Amount 金额', type: 'number' }}>
                                                {Math.abs(Number(data9[0].totalDay || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            </Compared>
                                        </Col>
                                    </Row>

                                </div>
                            </div>
                            <div className="receive-row" >
                                <div className="row-left">
                                    % 百分比
                                </div>
                                <div className="row-right">
                                    <Row style={{ textAlign: "center" }}>
                                        <Col span={4} className="border-right">
                                            <Compared data={{ index: 0, key: 'zeroPercent', title: ['0-30Days'], sqlName: "_9_2_1", name: '% 百分比', type: 'percent' }}>
                                                {Number(data9[0].zeroPercent || "0") < 0 ? <span style={{ color: "red" }}>({(Math.abs(data9[0].zeroPercent || "0") * 100).toFixed(1) + '%'})</span> : (Number(data9[0].zeroPercent || "0") * 100).toFixed(1) + '%'}
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right">
                                            <Compared data={{ index: 0, key: 'threePercent', title: ['31-60Days'], sqlName: "_9_2_1", name: '% 百分比', type: 'percent' }}>
                                                {Number(data9[0].threePercent || "0") < 0 ? <span style={{ color: "red" }}>({(Math.abs(data9[0].threePercent || "0") * 100).toFixed(1) + '%'})</span> : (Number(data9[0].threePercent || "0") * 100).toFixed(1) + '%'}
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right">
                                            <Compared data={{ index: 0, key: 'sixPercent', title: ['61-90Days'], sqlName: "_9_2_1", name: '% 百分比', type: 'percent' }}>
                                                {Number(data9[0].sixPercent || "0") < 0 ? <span style={{ color: "red" }}>({(Math.abs(data9[0].sixPercent || "0") * 100).toFixed(1) + '%'})</span> : (Number(data9[0].sixPercent || "0") * 100).toFixed(1) + '%'}
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right">
                                            <Compared data={{ index: 0, key: 'ninePercent', title: ['91-120Days'], sqlName: "_9_2_1", name: '% 百分比', type: 'percent' }}>
                                                {Number(data9[0].ninePercent || "0") < 0 ? <span style={{ color: "red" }}>({(Math.abs(data9[0].ninePercent || "0") * 100).toFixed(1) + '%'})</span> : (Number(data9[0].ninePercent || "0") * 100).toFixed(1) + '%'}
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right">
                                            <Compared data={{ index: 0, key: 'overPercent', title: ['Over 120 Days'], sqlName: "_9_2_1", name: '% 百分比', type: 'percent' }}>
                                                {Number(data9[0].overPercent || "0") < 0 ? <span style={{ color: "red" }}>({(Math.abs(data9[0].overPercent || "0") * 100).toFixed(1) + '%'})</span> : (Number(data9[0].overPercent || "0") * 100).toFixed(1) + '%'}
                                            </Compared>
                                        </Col>
                                        <Col span={4} className="border-right">
                                            <Compared data={{ index: 0, key: 'totalPercent', title: ['Total Balance'], sqlName: "_9_2_1", name: '% 百分比', type: 'percent' }}>
                                                {Number(data9[0].totalPercent || "0") < 0 ? <span style={{ color: "red" }}>({(Math.abs(data9[0].totalPercent || "0") * 100).toFixed(1) + '%'})</span> : (Number(data9[0].totalPercent || "0") * 100).toFixed(1) + '%'}
                                            </Compared>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="receive-row" >
                                <div className="row-left">
                                    Accounts over 90 Days 超90天应收账账户名
                                </div>
                                <div className="row-right">
                                    <Row style={{ textAlign: "center" }}>
                                        <Col span={4} className="border-right-background">
                                            Amount 金额
                                        </Col>
                                        <Col span={20} className="border-right-background">
                                            GM and DOF Comments 总经理及财务总监备注
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                        </div>}


                        <div
                        // style={{ height: 500, overflow: "auto" }}
                        >
                            {this.state.loading && !this.state.print ? null :
                                data.map((x, i) => {
                                    if (i === data.length - 1) {
                                        return (
                                            <div className="receive-row" key={i} >
                                                <div className="border-total">
                                                    {x.name}
                                                </div>
                                                <div className="row-right">
                                                    <Row style={{ textAlign: "center" }}>
                                                        <Col span={4} className="border-right-bottom">
                                                            {Number(x.money) < 0 ? <span style={{ color: "red" }}>({Math.abs(x.money)})</span> : x.money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        </Col>
                                                        <Col span={20} className="border-right-bottom" style={{ textAlign: "center" }}>
                                                            -
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        )
                                    }
                                    return (
                                        <div className="receive-row" key={i} >
                                            <div className="border-bottom-left-total">
                                                <Input
                                                    defaultValue={x.name}
                                                    className="table_numInput"
                                                    onBlur={(e) => {
                                                        let data = this.state.data;
                                                        data[i].name = e.target.value;
                                                        data[i].name_code = e.target.value;
                                                        this.setState({
                                                            data
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div className="row-right">

                                                <Row style={{ textAlign: "center" }}>
                                                    <Col span={4} className="border-right-input">
                                                        <Compared data={{ index: i, key: 'money', title: ['Amount 金额'], sqlName: "_9_2", name: x.name, type: 'number' }}>
                                                            <InputNumber
                                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                                precision={0}
                                                                defaultValue={Number(x.money || '0') || ''}
                                                                className="table_numInput"
                                                                onBlur={(e) => {
                                                                    let data = this.state.data;
                                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                                    value = Number(value.toFixed(0));
                                                                    data[i].money = value;

                                                                    let money = data.reduce((a, b) => {
                                                                        if (b.name != "Total") {
                                                                            a += Number(b.money || "0");
                                                                        }
                                                                        return a
                                                                    }, 0)
                                                                    data[data.length - 1].money = money;
                                                                    this.setState({
                                                                        data
                                                                    });
                                                                }}
                                                            />
                                                        </Compared>
                                                    </Col>
                                                    <Col span={20} className="border-right-input">
                                                        <Input
                                                            className="table_numInput"
                                                            defaultValue={x.note}
                                                            onBlur={(e) => {
                                                                let data = this.state.data;
                                                                data[i].note = e.target.value;
                                                                this.setState({
                                                                    data
                                                                });
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>

                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_9_2">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-2/index.js